import styled from 'styled-components';

/**
 * Full-mode field grid. All column counts default independently.
 *
 * `$columns`   — column count at default (large) size. Default: 4.
 * `$mdColumns` — column count at ≤789px. Default: 3.
 * `$smColumns` — column count at ≤480px. Default: 2.
 *
 * Pass all three props explicitly when overriding to make the layout clear
 * at every breakpoint.
 */
export const FieldsRow = styled.div<{ $columns?: number; $mdColumns?: number; $smColumns?: number }>`
    display: grid;
    grid-template-columns: repeat(${({ $columns }) => $columns ?? 4}, 1fr);
    gap: 1rem;
    margin-bottom: 1rem;

    @media (max-width: 789px) {
        grid-template-columns: repeat(${({ $mdColumns }) => $mdColumns ?? 3}, 1fr);
    }

    @media (max-width: 480px) {
        grid-template-columns: repeat(${({ $smColumns }) => $smColumns ?? 2}, 1fr);
    }
`;

/**
 * Summary/compact field grid: always 2 columns, no responsive collapse.
 */
export const SummaryFieldsRow = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
    margin-bottom: 1rem;
`;

/**
 * Wraps a field to span 2 columns within its parent FieldsRow.
 */
export const FieldSpan2 = styled.div`
    grid-column: span 2;
`;
